 document.addEventListener("DOMContentLoaded", function () {
    const scrollContainer = document.querySelector(".thumbnail_ctm_slider_list");
    const leftArrow = document.querySelector(".left-scroll-icon");
    const rightArrow = document.querySelector(".right-scroll-icon");

    const scrollAmount = 200; // Adjust this to control how much it scrolls

    if (rightArrow && leftArrow) {
      rightArrow.addEventListener("click", () => {
        scrollContainer.scrollBy({
          left: scrollAmount,
          behavior: "smooth"
        });
      });
  
      leftArrow.addEventListener("click", () => {
        scrollContainer.scrollBy({
          left: -scrollAmount,
          behavior: "smooth"
        });
      });
    }
  });

// --- Subscription product qty hide ---
function normalize(str) {
  return str.toLowerCase().replace(/\s+/g, ' ').trim();
}

function hideQtyForSubscriptionItems() {
  fetch('/cart.js')
    .then(res => res.json())
    .then(cart => {
      const subscriptionItems = cart.items
        .map((item, index) => ({
          index,
          title: normalize(item.title),
          variant: normalize(item.variant_title || ''),
          isSubscription: !!item.selling_plan_allocation,
          selling_plan_allocation: item.selling_plan_allocation,
          id: item.id,
          subscriptionProd: item.properties ? item.properties.subscription_prod : null
        }))
        .filter(item => item.isSubscription);

      // console.log('Subscription items with index:', subscriptionItems);

      if (!subscriptionItems.length) return;

      document.querySelectorAll('.cartItem__94aa13').forEach((cartItem, domIndex) => {
        const titleEl = cartItem.querySelector('.cartItemTitle__94aa13');
        const variantEl = cartItem.querySelector('.cartItemOptions__94aa13 span');

        if (!titleEl || !variantEl) return;

        const domTitle = normalize(titleEl.childNodes[0]?.textContent || '');
        const domVariant = normalize(variantEl.textContent || '');

        // Find the matching subscription item
        const matchingSubscriptionItem = subscriptionItems.find(
          item => item.index === domIndex &&
                  item.title === domTitle &&
                  item.variant === domVariant
        );

        if (matchingSubscriptionItem) {
          const qtyContainer = cartItem.querySelector('.quantityContainer__94aa13');
          if (qtyContainer) {
            if (!cartItem.querySelector('.subscriptionPlanText')) {
              const planText = document.createElement('div');
              planText.className = 'subscriptionPlanText';
              planText.textContent = matchingSubscriptionItem.selling_plan_allocation.selling_plan.name;
              planText.style.marginBottom = '4px';
              planText.style.fontWeight = '500';
              planText.style.color = '#333';
              planText.style.fontSize = '11px';

              qtyContainer.parentNode.insertBefore(planText, qtyContainer);
            }

            // Hide the quantity selector for subscription items
            qtyContainer.style.display = 'none';
          }
        }
      });
  })
  .catch(err => console.error('Error:', err));
}

document.addEventListener('DOMContentLoaded', hideQtyForSubscriptionItems);

// Observe mutations to detect cart updates and re-run the function
const observer = new MutationObserver(hideQtyForSubscriptionItems);
observer.observe(document.body, {
  childList: true,
  subtree: true
});


// Update ATC price
let originalPrice = null;

function getOneTimePrice() {
  const el = document.querySelector(
    ".sls-option-container [data-one-time-option-radio] " +
    ".sls-one-time-price .money"
  );
  return el ? el.textContent.trim() : null;
}

function getSubscriptionPrice(subscriptionActive) {
  const el = subscriptionActive?.querySelector(".sls-price .money");
  return el ? el.textContent.trim() : null;
}

function SubsAdded() {
  const isOnePack = document.querySelector("#variant-1pack")?.checked;

  const subscriptionActive = document.querySelector(
    ".sls-option-container.sls-active[data-selling-plan-group]"
  );

  const atcPriceEl = document.querySelector(
    "form .add-to-cart-btn [data-product-price]"
  );

  if (!atcPriceEl) return;

  if (!originalPrice) {
    // originalPrice = getOneTimePrice();
    originalPrice = atcPriceEl.textContent.trim();
    console.log("Original Price : ", originalPrice);
  }

  if (isOnePack && subscriptionActive) {
    const subscriptionPrice = getSubscriptionPrice(subscriptionActive);

    if (subscriptionPrice && atcPriceEl.textContent.trim() !== subscriptionPrice) {
      atcPriceEl.textContent = subscriptionPrice;
      console.log("ATC synced to subscription price:", subscriptionPrice);
    }
  } else if (isOnePack) {
    if (originalPrice && atcPriceEl.textContent.trim() !== originalPrice) {
      atcPriceEl.textContent = originalPrice;
      console.log("ATC reverted to original price:", originalPrice);
    }
  }
}

document.querySelector("#variant-1pack")?.addEventListener("change", SubsAdded);

document.addEventListener("change", (e) => {
  if (
    e.target.classList.contains("sls-option") ||
    e.target.classList.contains("sls-select")
  ) {
    setTimeout(SubsAdded, 50);
  }
});

document.addEventListener("click", () => {
  setTimeout(SubsAdded, 300);
});